export { getTruncatedNumber } from './getTruncatedNumber';
